import type { FC } from 'react';
import { useEffect } from 'react';

// V2 styles implemented according to integration guide
// https://new-work.atlassian.net/wiki/spaces/CMNW/pages/528449691/Implementation+guide

export const DarkColorschemeV2: FC = () => {
  // set default color
  const bgColor = '#161C24';
  const primaryColor = '#C6F16D';
  const acceptBtnBorderColor = '#C6F16D';
  const acceptBtnFontColor = '#1D2124';
  const acceptBtnHoverBgColor = '#A7E770';
  const acceptBtnHoverBgBorderColor = '#A7E770';
  const customBtnColor = '#616D7D';
  const customBtnBorderColor = '#616D7D';
  const customBtnFontColor = '#FFFFFF';
  const customBtnHoverBgColor = '#414D5D';
  const customBtnHoverBgBorderColor = '#414D5D';
  const denyBtnColor = '#616D7D';
  const denyBtnBorderColor = '#616D7D';
  const denyBtnFontColor = '#FFFFFF';
  const denyBtnHoverBgColor = '#414D5D';
  const denyBtnHoverBgBorderColor = '#414D5D';
  const saveBtnColor = '#616D7D';
  const saveBtnBorderColor = '#616D7D';
  const saveBtnFontColor = '#FFFFFF';
  const saveBtnHoverBgColor = '#414D5D';
  const saveBtnHoverBgBorderColor = '#414D5D';
  const secondLayerTabColor = '#004673';
  const secondLayerTabBorderColor = '#004673';
  const activeToggleFillColor = '#ffffff';
  const activeToggleIconFillColor = '#1D2124';
  const disableToggleFillColor = '#414D5D';
  const iconFillColor = '#C6F16D';
  const fontfamily = 'Xing Sans, helvetica, arial, sans-serif';
  const fontcolor = '#FFFFFF';
  const anchorlinkColor = '#0698A0';
  const accentColor = '#8A9DA6';

  const customStyle = `              :host(#usercentrics-root) div[data-testid="uc-buttons-container"], :host(#usercentrics-root) div[data-testid="first-line-buttons"] {justify-content: flex-end;}
              :host(#usercentrics-root) button[data-testid="uc-save-button"], :host(#usercentrics-root) div[data-testid="uc-customize-button"], :host(#usercentrics-root) div[data-testid="uc-deny-all-button"] {
                  flex: 0;
                  white-space: pre;
                  cursor: pointer;
                  font-weight: bold;
                  ${fontfamily ? 'font-family: ' + fontfamily + ';' : ''}
                  ${fontcolor ? 'color: ' + fontcolor + ';' : ''}
                  border: 1px solid #000000;
                  line-height: 1.25rem;
                  font-size: 16px;
                  height: 2.5rem;
                  padding: 0.3125rem 1.5rem;
              }
              :host(#usercentrics-root) button[data-testid="uc-save-button"] {
                  white-space: pre;
                  cursor: pointer;
                  font-weight: bold;
                  ${fontfamily ? 'font-family: ' + fontfamily + ';' : ''}
                  ${saveBtnColor ? 'background-color: ' + saveBtnColor + ';' : ''}
                  ${saveBtnFontColor ? 'color: ' + saveBtnFontColor + ';' : ''}
                  border: 1px solid ${saveBtnBorderColor};
                  line-height: 1.25rem;
                  font-size: 16px;
                  height: 2.5rem;
                  padding: 0.3125rem 1.5rem;
              }
              :host(#usercentrics-root) button[data-testid="uc-save-button"]:active, :host(#usercentrics-root) button[data-testid="uc-save-button"]:hover {
                  background-color: ${saveBtnHoverBgColor};
                  border: 1px solid ${saveBtnHoverBgBorderColor};
              }
              :host(#usercentrics-root) button[data-testid="uc-deny-all-button"] {
                  white-space: pre;
                  cursor: pointer;
                  font-weight: bold;
                  ${fontfamily ? 'font-family: ' + fontfamily + ';' : ''}
                  ${denyBtnColor ? 'background-color: ' + denyBtnColor + ';' : ''}
                  ${denyBtnFontColor ? 'color: ' + denyBtnFontColor + ';' : ''}
                  border: 1px solid ${denyBtnBorderColor};
                  line-height: 1.25rem;
                  font-size: 16px;
                  height: 2.5rem;
                  padding: 0.3125rem 1.5rem;
              }
              :host(#usercentrics-root) button[data-testid="uc-deny-all-button"]:active, :host(#usercentrics-root) button[data-testid="uc-deny-all-button"]:hover {
                  background-color: ${denyBtnHoverBgColor};
                  border: 1px solid ${denyBtnHoverBgBorderColor};
              }
              :host(#usercentrics-root) button[data-testid="uc-accept-all-button"] {
                  white-space: pre;
                  cursor: pointer;
                  font-weight: bold;
                  ${fontfamily ? 'font-family: ' + fontfamily + ';' : ''}
                  ${primaryColor ? 'background-color: ' + primaryColor + ';' : ''}
                  ${acceptBtnFontColor ? 'color: ' + acceptBtnFontColor + ';' : ''}
                  border: 1px solid ${acceptBtnBorderColor};
                  line-height: 1.25rem;
                  font-size: 16px;
                  height: 2.5rem;
                  padding: 0.3125rem 1.5rem;
              }
              :host(#usercentrics-root) button[data-testid="uc-accept-all-button"]:active, :host(#usercentrics-root) button[data-testid="uc-accept-all-button"]:hover {
                  background-color: ${acceptBtnHoverBgColor};
                  border: 1px solid ${acceptBtnHoverBgBorderColor};
              }
              :host(#usercentrics-root) button[data-testid="uc-customize-button"] {
                  white-space: pre;
                  cursor: pointer;
                  font-weight: bold;
                  ${fontfamily ? 'font-family: ' + fontfamily + ';' : ''}
                  ${customBtnColor ? 'background-color: ' + customBtnColor + ';' : ''}
                  ${customBtnFontColor ? 'color: ' + customBtnFontColor + ';' : ''}
                  border: 1px solid ${customBtnBorderColor};
                  line-height: 1.25rem;
                  font-size: 16px;
                  height: 2.5rem;
                  padding: 0.3125rem 1.5rem;
              }
              :host(#usercentrics-root) button[data-testid="uc-customize-button"]:active, :host(#usercentrics-root) button[data-testid="uc-customize-button"]:hover {
                  background-color: ${customBtnHoverBgColor};
                  border: 1px solid ${customBtnHoverBgBorderColor};
              }
              :host(#usercentrics-root) #uc-tab-list {
                  border-bottom: none;
                  padding-bottom: .5em;
              }
              :host(#usercentrics-root) #uc-tab-list button {
                  border-bottom-width: 0.25rem;
                  width: auto;
                  border-bottom: 0.25rem solid transparent;
                  height: 2.5rem;
              }
              :host(#usercentrics-root) #uc-tab-list button:first-child { margin-right: 1rem }
              :host(#usercentrics-root) #uc-tab-list button[aria-selected="true"] {
                  ${secondLayerTabBorderColor ? 'border-bottom-color: ' + secondLayerTabBorderColor + ';' : ''}
                  ${secondLayerTabColor ? 'color: ' + secondLayerTabColor + ';' : ''}
              }
              :host(#usercentrics-root) #uc-tab-list button[aria-selected="false"]:hover { border-bottom: 0.25rem solid rgb(180, 180, 180) }
              :host(#usercentrics-root) div[data-testid="uc-heading-title"] {
                  font-size: 20px;
                  font-weight: bold;
                  line-height: 24px;
                  color: ${fontcolor} !important;
              }
              :host(#usercentrics-root) h1 {
                  color: ${fontcolor} !important;
              }
              :host(#usercentrics-root) div {
                  color: ${fontcolor} !important;
              }
              :host(#usercentrics-root) div[data-testid="uc-headinger-wrapper"] {
                  padding: 0;
              }
              :host(#usercentrics-root) a, :host(#usercentrics-root), button[data-testid="uc-customize-anchor"] {
                  text-decoration: underline;
                  ${anchorlinkColor ? 'color: ' + anchorlinkColor + ';' : ''}
              }
              :host(#usercentrics-root) #uc-center-container {
                  margin: 15px auto 0;
                  padding: 0.5rem 0.5rem 1rem 0.5rem;
                  max-width: 750px;
                  width: 75%;
                  background-color: ${bgColor} !important;
                  color: ${fontcolor} !important;
              }
              :host(#usercentrics-root) div[data-testid^="uc-tab-"] {
                  height: 2.5rem;
              }
              :host(#usercentrics-root) div[data-testid="uc-virtual-list"], :host(#usercentrics-root) div[data-testid="uc-footer"], :host(#usercentrics-root) div[data-testid="uc-header"], :host(#usercentrics-root) div[data-testid="uc-container"], :host(#usercentrics-root) div[data-testid="uc-vertical-scroller"], :host(#usercentrics-root) div[data-testid="uc-fading-wrapper"] {
                  background-color: ${bgColor} !important;
                  color: ${fontcolor} !important;
              }
              :host(#usercentrics-root) div[data-testid="uc-message-container"], :host(#usercentrics-root) div[data-testid="uc-tcf-special-features-expandable"], :host(#usercentrics-root) .fPIomt, :host(#usercentrics-root) .gQkCVK, :host(#usercentrics-root) .dcZhgd, :host(#usercentrics-root) .jyhSvn,  :host(#usercentrics-root) div[data-testid="uc-controller-id"], :host(#usercentrics-root) .eRBBB,  :host(#usercentrics-root) .MTiNp, :host(#usercentrics-root) div[data-testid="uc-button-container"], :host(#usercentrics-root) .eovTkN, :host(#usercentrics-root) .gMirTG, :host(#usercentrics-root) .hBXoRr, :host(#usercentrics-root) .ecEeWf, :host(#usercentrics-root) .sc-bVHCgj,  :host(#usercentrics-root) .sc-dlWCHZ, :host(#usercentrics-root) .jVWyUf, :host(#usercentrics-root) .bOKSaM, :host(#usercentrics-root) .dwDpwZ, :host(#usercentrics-root) .fETenW, :host(#usercentrics-root) .eVwFlK, :host(#usercentrics-root) .eRbJab, :host(#usercentrics-root) .cctawx, :host(#usercentrics-root) .hziMai, :host(#usercentrics-root) .hcOTIC, :host(#usercentrics-root) .bZpiHQ, :host(#usercentrics-root) .hLMbOU, :host(#usercentrics-root) .gMUeZo, :host(#usercentrics-root) .sc-kAkpmW, :host(#usercentrics-root) .dCbhkb, :host(#usercentrics-root) div[data-testid="uc-expandable-content"], :host(#usercentrics-root) div[data-testid="uc-tcf-vendors-expandable"], :host(#usercentrics-root) div[data-testid="uc-tcf-features-expandable"], :host(#usercentrics-root) div[data-testid="uc-tcf-special-purposes-expandable"], :host(#usercentrics-root) div[data-testid="uc-tcf-purposes-expandable"], :host(#usercentrics-root) button[data-testid="uc-tab-vendors"], :host(#usercentrics-root) div[data-testid="uc-panel-vendors"], :host(#usercentrics-root) div[data-testid="uc-panel-purposes"], :host(#usercentrics-root) button[data-testid="uc-tab-purposes"], :host(#usercentrics-root) .iZA-dmM, :host(#usercentrics-root) .ibjfsz, :host(#usercentrics-root) div[data-testid="uc-expandable-card"], :host(#usercentrics-root) div[data-testid="uc-header-wrapper"], :host(#usercentrics-root) div[role="tab"], :host(#usercentrics-root) div[role="tablist"], :host(#usercentrics-root) div[role="heading"], :host(#usercentrics-root) .cYPgfe, :host(#usercentrics-root) .kYXrjW {
                  background-color: ${bgColor} !important;
                  color: ${fontcolor} !important;
              }
              :host(#usercentrics-root) div[data-testid="uc-tcf-categories"] {
                  border-bottom:1px solid ${accentColor};
                  background-color: ${bgColor} !important;
                  color: ${fontcolor} !important;
              }
               :host(#usercentrics-root) .OnyZN {
                  border-top:1px solid ${accentColor};
                  background-color: ${bgColor} !important;
                  color: ${fontcolor} !important;
              }
              :host(#usercentrics-root) .lmyDvo {
                  background-color: ${bgColor} !important;
                  color: ${fontcolor} !important;
              }
              :host(#usercentrics-root) .fXfmQT {
                  background-color: ${bgColor} !important;
              }
              :host(#usercentrics-root) .fBYHiB, :host(#usercentrics-root) .ixqgEt {
                  border-color: ${fontcolor} !important;
              }
              :host(#usercentrics-root) #uc-tab-list button[aria-selected="true"]{
                  border-bottom-color: ${fontcolor};
              }
`;

  useEffect(() => {
    const cb: MutationCallback = (_, observer) => {
      const usercentricsRoot =
        document.querySelector<HTMLDivElement>('#usercentrics-root');
      if (usercentricsRoot) {
        observer.disconnect();

        const styleElement = document.createElement('style');
        styleElement.innerHTML = customStyle;
        try {
          usercentricsRoot.shadowRoot?.appendChild(styleElement);
        } catch (e) {
          console.error(e);
        }

        try {
          const sroot = usercentricsRoot.shadowRoot?.querySelector<HTMLElement>(
            "[data-testid='uc-app-container']"
          );

          if (sroot) {
            const cb2: MutationCallback = () => {
              // Updating styles based on conditions
              try {
                if (activeToggleFillColor) {
                  const paths = sroot.querySelectorAll(
                    "button[data-testid='uc-language-button'] svg g > g > path:nth-child(1)"
                  ) as NodeListOf<any>;
                  paths.forEach((path: SVGElement) =>
                    path.setAttribute('fill', iconFillColor)
                  );
                }
                try {
                  if (activeToggleFillColor) {
                    const paths = sroot.querySelectorAll(
                      "button[data-testid='uc-close-button'] svg > path:nth-child(1)"
                    );
                    paths.forEach((path) =>
                      path.setAttribute('fill', iconFillColor)
                    );
                  }
                } catch (e) {
                  console.error(e);
                }

                try {
                  if (activeToggleFillColor) {
                    const paths = sroot.querySelectorAll(
                      "button[aria-disabled='false'][aria-checked='true'] svg g > g > g > path:nth-child(1)"
                    );
                    paths.forEach((path) =>
                      path.setAttribute('fill', activeToggleFillColor)
                    );
                  }
                } catch (e) {
                  console.error(e);
                }

                try {
                  if (activeToggleFillColor) {
                    const paths = sroot.querySelectorAll(
                      "button[aria-disabled='false'][aria-checked='true'] svg g > g > g > path:nth-child(2)"
                    );
                    paths.forEach((path) =>
                      path.setAttribute('fill', activeToggleIconFillColor)
                    );
                  }
                } catch (e) {
                  console.error(e);
                }

                try {
                  if (activeToggleFillColor) {
                    const paths = sroot.querySelectorAll(
                      "button[aria-disabled='false'][aria-checked='true'] svg g > g > g > path:nth-child(3)"
                    );
                    paths.forEach((path) =>
                      path.setAttribute('fill', activeToggleIconFillColor)
                    );
                  }
                } catch (e) {
                  console.error(e);
                }

                try {
                  if (activeToggleFillColor) {
                    const paths = sroot.querySelectorAll(
                      "button[aria-disabled='false'][aria-checked='false'] svg g > g > g > path:nth-child(1)"
                    );
                    paths.forEach((path) =>
                      path.setAttribute('fill', activeToggleFillColor)
                    );
                  }
                } catch (e) {
                  console.error(e);
                }

                try {
                  if (activeToggleFillColor) {
                    const paths = sroot.querySelectorAll(
                      "button[aria-disabled='false'][aria-checked='false'] svg g > g > g > path:nth-child(2)"
                    );
                    paths.forEach((path) =>
                      path.setAttribute('fill', activeToggleIconFillColor)
                    );
                  }
                } catch (e) {
                  console.error(e);
                }

                try {
                  if (activeToggleFillColor) {
                    const paths = sroot.querySelectorAll(
                      "button[aria-disabled='false'][aria-checked='false'] svg g > g > g > path:nth-child(3)"
                    );
                    paths.forEach((path) =>
                      path.setAttribute('fill', activeToggleIconFillColor)
                    );
                  }
                } catch (e) {
                  console.error(e);
                }
                try {
                  if (activeToggleFillColor) {
                    const paths = sroot.querySelectorAll(
                      "button[aria-disabled='true'][aria-checked='true'] svg > g > g > g > path:nth-child(1)"
                    );
                    paths.forEach((path) =>
                      path.setAttribute('fill', disableToggleFillColor)
                    );
                  }
                } catch (e) {
                  console.error(e);
                }

                try {
                  if (activeToggleFillColor) {
                    const paths = sroot.querySelectorAll(
                      "button[aria-label='Details des Services ansehen'] svg > path:nth-child(2)"
                    );
                    paths.forEach((path) =>
                      path.setAttribute('fill', fontcolor)
                    );
                  }
                } catch (e) {
                  console.error(e);
                }

                // Remove UC Branding
                try {
                  sroot
                    .querySelector('a[href*="usercentrics.com"]')
                    ?.closest('div')
                    ?.remove();
                } catch (e) {
                  console.error(e);
                }
              } catch (e) {
                console.error(e);
              }
            };

            const obs2 = new MutationObserver(cb2);
            obs2.observe(sroot, obsOptions);
          }
        } catch (e) {
          console.error(e);
        }
      }
    };

    const target = document.querySelector('html');
    const obsOptions: MutationObserverInit = {
      childList: true,
      attributes: false,
      subtree: true,
    };
    const obs = new MutationObserver(cb);
    if (target) {
      obs.observe(target, obsOptions);
    }

    return () => {
      obs.disconnect();
    };
  }, []);

  return null;
};
